import GenericDivider from "component_library/components/react/Divider"
import styled from "styled-components"

const Divider = styled(GenericDivider)`
  background-color: black;
  box-shadow: 0 1px 0 ${({ theme }) => theme.blue_700};
  gap: 0;
`

export default Divider
